import axios from "../../axios";
import { parseContentDispositionFilename } from "../../../utils/http";

// CATEGORY 4
const api = {
  getUpstreamTransportationAndDistributionItems(params, accessToken) {
    const config = {
      params: params.queryParams,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/organization-questionnaires/${params.questionnaireId}/upstream-transportation-distribution/items`,
      config).then(({ data }) => data);
  },

  addUpstreamTransportationAndDistributionItems({ questionnaireId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(`/organization-questionnaires/${questionnaireId}/upstream-transportation-distribution/items`,
      data, headers).then(({ data }) => data);
  },

  updateUpstreamTransportationAndDistributionItem({ questionnaireId, recordId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put(`/organization-questionnaires/${questionnaireId}/upstream-transportation-distribution/items/${recordId}`,
      data, headers).then(({ data }) => data);
  },

  deleteUpstreamTransportationAndDistributionItem({ questionnaireId, recordId }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.delete(`/organization-questionnaires/${questionnaireId}/upstream-transportation-distribution/items/${recordId}`,
      headers).then(({ data }) => data);
  },

  importUpstreamTransportationAndDistributionItems({ questionnaireId, data }, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post(`/organization-questionnaires/${questionnaireId}/upstream-transportation-distribution/items/import`,
      data, headers).then(({ data }) => data);
  },

  getUpstreamTransportationAndDistributionTemplate(questionnaireId, accessToken) {
    const config = {
      responseType: "arraybuffer",
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(
      `/organization-questionnaires/${questionnaireId}/upstream-transportation-distribution/template`, config
    ).then(({ data, headers }) => {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      const defaultFileName = parseContentDispositionFilename(
        headers["content-disposition"], "Scope3_Category4_template.xlsx");
      link.href = url;
      link.setAttribute("download", defaultFileName);
      document.body.appendChild(link);
      link.click();
      return true;
    });
  }
};

export default api;